import { render, staticRenderFns } from "./infoTransfer.vue?vue&type=template&id=68ca9e5d&"
import script from "./infoTransfer.vue?vue&type=script&lang=js&"
export * from "./infoTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports